import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from "../views/Login";
import Main from "../views/Main";
import ClassRoom from "../views/ClassRoom";
import Welcome from "../views/Welcome";
import Course from "../views/Course";
import Students from "../views/Students";
import Video from "../views/Video";
import Employment from "../views/Employment";
import EPMAddEdit from "../views/EPMAddEdit";
import LearnRecordCharts from "../views/LearnRecordCharts";
import TestPaper from "@/views/TestPaper";
import TestQuestions from "@/views/TestQuestions";
import Score from "@/views/Score";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'login',
        component: Login
    },
    {
        path: '/welcome',
        component: Main,
        children: [
            {
                path: '',
                component: Welcome,
                meta: {title: '数据看板'}
            }
        ]
    },
    {
        path: '/main',
        name: 'main',
        component: Main,
        redirect: '/welcome',
        children: [
            {
                path: 'students',
                component: Students,
                meta: {
                    title: '学生管理',
                    keepAlive: true
                }
            },
            {
                path: 'students/learnRecordCharts',
                component: LearnRecordCharts,
                meta: {
                    title: '学习记录',
                    keepAlive: false
                }
            },
            {
                path: 'classroom',
                component: ClassRoom,
                meta: {
                    title: '班级管理',
                    keepAlive: true
                }
            },
            {
                path: 'course',
                component: Course,
                meta: {
                    title: '课程管理',
                    keepAlive: true
                }
            },
            {
                path: 'video',
                component: Video,
                meta: {
                    title: '视频管理',
                    keepAlive: true
                }
            },
            {
                path: 'employment',
                name: 'employment',
                component: Employment,
                meta: {
                    title: '招聘管理',
                    keepAlive: true
                }
            },
            {
                path: 'employment/epmAddEdit',
                name: 'epmAddEdit',
                component: EPMAddEdit,
                meta: {title: '招聘管理'}
            },
            {
                path: 'testPaper',
                name: 'testPaper',
                component: TestPaper,
                meta: {title: '试卷管理'}
            },
            {
                path: 'testQuestions',
                name: 'testQuestions',
                component: TestQuestions,
                meta: {title: '试题管理'}
            },
            {
                path: 'score',
                name: 'score',
                component: Score,
                meta: {title: '成绩管理'}
            }
        ]
    }
];

const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    }
});

/*
在路由中添加了相同的路由会报错，需要重写catch
 */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};

export default router;
